import styled, { keyframes } from 'styled-components';

import { CALIBRATE, CALIBRATE_ANIM } from '../../../../theme/tokens';

/**
 * The reticle ring rides the SAME focal rack as the bokeh field (matching stops + the shared
 * CALIBRATE_ANIM.focusHuntMs clock, at depth 0 / zero delay), so the ring and the field snap
 * into focus together rather than on independent timers. It is crisp through the dwell at the
 * cycle ends (with a focus-lock glow blooming) and softest in the middle (glow gone), with a
 * dip in opacity on the soft frames so it reads as a lens settling on its subject. Glow and
 * blur are folded into one `filter` list so they animate together.
 */
const ringFocus = keyframes`
  0%, 12% { filter: blur(0px) drop-shadow(0 0 7px ${CALIBRATE.ringGlow}); opacity: 1; }
  50% { filter: blur(9px) drop-shadow(0 0 0 transparent); opacity: 0.58; }
  88%, 100% { filter: blur(0px) drop-shadow(0 0 7px ${CALIBRATE.ringGlow}); opacity: 1; }
`;

/** 64x64 focus glyph. The frame brackets inherit `currentColor` (themed ink) and stay sharp;
 *  only the ring carries the focus animation. */
export const FocusSvg = styled.svg`
  display: block;
  width: 64px;
  height: 64px;
  color: ${CALIBRATE.iconFrame};
  fill: currentColor;
`;

/** The reticle ring (annulus): the part that blur-racks focus. Inherits the frame ink, so
 *  the icon stays monochrome; holds a static, sharp frame under reduced motion. */
export const Ring = styled.path`
  animation: ${ringFocus} ${CALIBRATE_ANIM.focusHuntMs}ms ${CALIBRATE_ANIM.ease} infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    filter: none;
    opacity: 1;
  }
`;
